import { IRootState } from '../../../store'

export const getAuthenticationJwtSelector = (state: IRootState): string | null => state.login.authenticationJwt
